import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import LogoutIcon from "@mui/icons-material/Logout";
import { useGlobalContext } from "../../../context/store";
import { useNavigate } from "react-router-dom";
import { SessionLogout } from "../../../session/session";

// custom confirm modal
import { useCustomConfirm } from "../../custom-confirm-box/useCustomConfirm";
import ConfirmModal from "../../custom-confirm-box/ConfirmModal";
import ErrorBoundary from "../../../ErrorBoundary";

export default function Header({
  cookieSessionName,
}: {
  cookieSessionName: string;
}) {
  const { toggleSidebar } = useGlobalContext();

  // custom confirm box
  const {
    isOpen,
    message,
    customConfirm,
    handleCancel,
    handleConfirm,
    confirmText,
  } = useCustomConfirm();

  const navigate = useNavigate();

  const currentPath = window.location.hash;

  const [open, setOpen] = useState(false);

  const handleTooltipToggle = () => {
    setOpen(!open);
  };

  const darkModeSwitch = useRef<HTMLInputElement>(null);

  var theme = "";

  if (typeof localStorage !== "undefined") {
    theme = localStorage?.getItem("theme") || "";
  }

  if (theme === "dark") {
    if (darkModeSwitch.current) {
      darkModeSwitch.current.checked = false;
    }
    if (typeof document !== "undefined") {
      document.documentElement.classList.add("dark");
    }
  } else {
    if (darkModeSwitch.current) {
      darkModeSwitch.current.checked = true;
    }
    if (typeof document !== "undefined") {
      document.documentElement.classList.remove("dark");
    }
  }

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  return (
    <ErrorBoundary>
      <div className="header mw-100 bg-white dark:bg-slate-700">
        <div className="flex justify-between py-2 px-5">
          <h3 className="dark:text-white" onClick={() => toggleSidebar()}>
            <MenuIcon role="button" />
          </h3>
          {/* <div className="grid grid-cols-2 gap-x-6"> */}
          <div className="grid grid-cols-1 gap-x-6">
            {/* <div className="dark-light-toggle my-auto">
            <label className="switch">
              <input
                type="checkbox"
                ref={darkModeSwitch}
                defaultChecked
                onChange={(e) => {
                  if (!e.target.checked) {
                    if (typeof document !== "undefined") {
                      document.documentElement.classList.add("dark");
                    }
                    if (typeof localStorage !== "undefined") {
                      localStorage?.setItem("theme", "dark");
                    }
                  } else {
                    if (typeof document !== "undefined") {
                      document.documentElement.classList.remove("dark");
                    }
                    if (typeof localStorage !== "undefined") {
                      localStorage?.setItem("theme", "light");
                    }
                  }
                }}
              />
              <span className="slider"></span>
            </label>
          </div> */}
            <HtmlTooltip
              open={open}
              onClose={() => setOpen(false)}
              title={
                <React.Fragment>
                  <div
                    className="text-blue-700 font-extrabold mb-1 mt-1"
                    // className="text-blue-700 hover:text-blue-600 hover:underline font-extrabold mb-1 mt-1"
                    // to={`/users/profile/${cookieSessionEmail}`}
                  >
                    <h2 className="text-center cursor-default">
                      {cookieSessionName ? cookieSessionName : "Anonymous"}
                    </h2>
                  </div>

                  {/* <Link
                  className="w-full text-center mt-3"
                  to={"/change-password"}
                >
                  <Button
                    className="text-center mx-auto py-1 px-2"
                    size="small"
                  >
                    Change Password
                  </Button>
                </Link> */}

                  <div className="w-full text-center">
                    <Button
                      className="text-center mx-auto"
                      onClick={async () => {
                        customConfirm(
                          "Are you sure? You will be logged Out!!",
                          async () => {
                            await SessionLogout();
                            navigate("/login");
                          }
                        );
                      }}
                    >
                      <h3>
                        Logout? &nbsp; <LogoutIcon className="my-auto" />
                      </h3>
                    </Button>
                  </div>
                </React.Fragment>
              }
            >
              <h3>
                <div className="w-8 h-8 text-center rounded-full bg-gradient-to-tl from-blue-200 to-violet-300 flex justify-center">
                  <Button
                    className="my-auto"
                    color="inherit"
                    onClick={() => handleTooltipToggle()}
                  >
                    <PersonIcon role="button" />
                  </Button>
                </div>
              </h3>
            </HtmlTooltip>
          </div>
        </div>
        <hr className="my-0" />
        <div className="breadcrumb py-2 px-3 dark:bg-slate-500">
          <div role="presentation">
            <Breadcrumbs aria-label="breadcrumb">
              {currentPath === "#/work-contract-register" && (
                <Typography
                  className="select-none"
                  fontSize={14}
                  color="text.primary"
                >
                  Work Contract Register
                </Typography>
              )}
              {currentPath === "#/fabric-inward-register" && (
                <Typography
                  className="select-none"
                  fontSize={14}
                  color="text.primary"
                >
                  Fabric Inward Register
                </Typography>
              )}
              {currentPath === "#/fabric-outward-register" && (
                <Typography
                  className="select-none"
                  fontSize={14}
                  color="text.primary"
                >
                  Fabric Outward Register
                </Typography>
              )}

              {currentPath === "#/status-update" && (
                <Typography
                  className="select-none"
                  fontSize={14}
                  color="text.primary"
                >
                  Status Update
                </Typography>
              )}
            </Breadcrumbs>
          </div>
        </div>

        <ConfirmModal
          isOpen={isOpen}
          message={message}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          confirmText={confirmText}
        />
      </div>
    </ErrorBoundary>
  );
}
